import Axios from "@/plugins/Axios";
import Disciplina from "@/Models/Disciplina";
import Serie from "@/Models/Serie";
import store from "@/store";

export class SeriesService {
  /**
   * Atualiza uma série existente
   * --
   * @param {Object} serie - Dados da série a ser atualizada
   * @returns {Promise<Object>} Série atualizada
   */
  async atualizarSerie(serie) {
    const response = await Axios().put(`series/${serie.id}`, serie);
    const serieAtualizada = response.data;

    store.commit("Series/atualizarSerie", serieAtualizada);

    return serieAtualizada;
  }

  /**
   * Cria uma nova série
   * --
   * @param {Object} serie - Dados da nova série
   * @returns {Promise<Object>} Série criada
   */
  async criarSerie(serie) {
    const response = await Axios().post("series", serie);
    const novaSerie = response.data;

    store.commit("Series/adicionarSerie", novaSerie);

    return novaSerie;
  }

  /**
   * Remove (soft delete) uma série
   * --
   * @param {Object} serie - Série a ser deletada
   * @returns {Promise<Object>} Série deletada
   */
  async deletarSerie(serie) {
    const response = await Axios().delete(`series/${serie.id}`);
    const serieDeletada = response.data;

    store.commit("Series/deletarSerie", serie.id);

    return serieDeletada;
  }

  /**
   * Busca disciplinas por ID da série
   * --
   * @param {number|string} id - ID da série
   * @returns {Promise<Array<Disciplina>>} Lista de disciplinas
   */
  async getDisciplinasBySerie(id) {
    const response = await Axios().get(`disciplinas/${id}`);
    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));

    return disciplinas;
  }

  /**
   * Busca uma série específica por ID
   * --
   * @param {number|string} serie_id - ID da série
   * @returns {Promise<Object>} Dados da série
   */
  async getSerie(serie_id) {
    const response = await Axios().get(`series/${serie_id}`);
    const serie = response.data.serie;

    return serie;
  }

  /**
   * Recupera uma série que foi deletada (soft delete)
   * --
   * @param {Object} serie - Série a ser recuperada
   * @returns {Promise<Object>} Série recuperada
   */
  async recuperarSerie(serie) {
    const serieRecuperada = { ...serie, deleted_at: null };

    return this.atualizarSerie(serieRecuperada);
  }

  /**
   * Sincroniza todas as séries do backend
   * --
   * @returns {Promise<Array<Serie>>} Lista de todas as séries
   */
  async syncAll() {
    const response = await Axios().get("series");
    const series = response.data.map((serie) => new Serie(serie));

    store.commit("Series/setSeries", series);

    return series;
  }
}

export default new SeriesService();
